import { type SDK_GetFilesQuery, type SDK_QpFile, type UploadFileType, getFilesByType } from "@quickpoint.me/shared";
import { atom, selector } from "recoil";

export const Files = atom<SDK_GetFilesQuery["getFiles"]>({
    key: "FU_Files",
    default: { files: [] },
});

export const AudioFiles = selector<SDK_QpFile[] | undefined>({
    key: "FU_AudioFiles",
    get: ({ get }) => {
        const files = get(Files)
        const audioFiles = files ? getFilesByType("audio", files.files) : []
        return audioFiles
    }
})


export const DataFiles = selector<SDK_QpFile[] | undefined>({
    key: "FU_DataFiles",
    get: ({ get }) => {
        const files = get(Files)
        const dataFiles = files ? getFilesByType("data", files.files) : []
        return dataFiles
    }
})


export const ImageFiles = selector<SDK_QpFile[] | undefined>({
    key: "FU_ImageFiles",
    get: ({ get }) => {
        const files = get(Files)
        const imageFiles = files ? getFilesByType("image", files.files) : []
        return imageFiles
    }
})



// increment this to reload all the images and reset their states.
export const FilesKeyForUiRefresh = atom<number>({
    key: "FU_FilesKeyForUiRefresh",
    default: 0,
});

export const FileTypeToDisplay = atom<UploadFileType | 'ai' | 'search'>({
    key: "FU_FileTypeToDisplay",
    default: "image"
})
